import request from '@/utils/request'

// 获取模型配置列表
export function getModelConfigList(params) {
  return request({
    url: '/models/list',
    method: 'get',
    params
  })
}

// 获取所有模型名称
export function getModelNames(params) {
  return request({
    url: '/models/names',
    method: 'get',
    params
  })
}

// 获取LLM模型信息
export function getLlmModelCodeList(params) {
  return request({
    url: '/models/llm/names',
    method: 'get',
    params
  })
}

// 获取模型供应器列表
export function getModelProviderList(modelType) {
  return request({
    url: `/models/${modelType}/provideTypes`,
    method: 'get'
  })
}

// 获取模型配置详情
export function getModelConfig(id) {
  return request({
    url: `/models/${id}`,
    method: 'get'
  })
}

// 新增模型配置
export function addModelConfig(modelType, provideCode, data) {
  return request({
    url: `/models/${modelType}/${provideCode}`,
    method: 'post',
    data
  })
}

// 编辑模型配置
export function editModelConfig(modelType, provideCode, id, data) {
  return request({
    url: `/models/${modelType}/${provideCode}/${id}`,
    method: 'put',
    data
  })
}

// 删除模型配置
export function deleteModelConfig(id) {
  return request({
    url: `/models/${id}`,
    method: 'delete'
  })
}

// 启用/关闭模型配置
export function enableModelConfig(id, status) {
  return request({
    url: `/models/enable/${id}/${status}`,
    method: 'put'
  })
}

// 设置模型开通状态
export function activateModelConfig(id, status) {
  return request({
    url: `/models/activate/${id}/${status}`,
    method: 'put'
  })
}

// 设置默认模型
export function setDefaultModel(id) {
  return request({
    url: `/models/default/${id}`,
    method: 'put'
  })
}

// 获取模型音色列表
export function getModelVoices(modelId, params) {
  return request({
    url: `/models/${modelId}/voices`,
    method: 'get',
    params
  })
}

// 获取音色列表
export function getVoiceList(params) {
  const queryParams = new URLSearchParams({
    ttsModelId: params.ttsModelId,
    page: params.page || 1,
    limit: params.limit || 10,
    name: params.name || ''
  }).toString();
  return request({
    url: `/ttsVoice?${queryParams}`,
    method: 'get'
  })
}

// 保存音色
export function saveVoice(data) {
  return request({
    url: '/ttsVoice',
    method: 'post',
    data
  })
}

// 修改音色
export function updateVoice(id, data) {
  return request({
    url: `/ttsVoice/${id}`,
    method: 'put',
    data
  })
}

// 删除音色
export function deleteVoice(ids) {
  return request({
    url: '/ttsVoice/delete',
    method: 'post',
    data: ids
  })
}

// 获取所有模型类型
export function getModelTypes() {
  return request({
    url: '/models/types',
    method: 'get'
  })
}

// 获取模型账户额度信息
export function getModelQuota(id, refresh = false) {
  return request({
    url: `/models/quota/${id}`,
    method: 'get',
    params: { refresh }
  })
}
